import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { CompanySchema, type Company } from "./organizationSchema";

type UseCompanySelectorOptions = {
    searchText?: string;
    enabled?: boolean;
    itemsPerPage?: number;
    hierarchyRootId?: number;
};

export const useOrganizationSelector = (options: UseCompanySelectorOptions = {}) => {
    const { searchText = "", enabled = true, itemsPerPage = 200, hierarchyRootId } = options;

    const fetchCompanies = async () => {
        const response = await loggedInApiCall.get<{ "hydra:member": unknown }>("/api/organizations", {
            params: {
                q: searchText,
                itemsPerPage,
                hierarchyRootId,
                order: { name: "ASC" },
            },
        });

        return zodParseWithLog(response.data["hydra:member"], CompanySchema.array(), "companySelector");
    };

    const query = useQuery<Company[], Error>({
        queryKey: ["companySelector", searchText, itemsPerPage, hierarchyRootId],
        queryFn: fetchCompanies,
        enabled: enabled,
        staleTime: 0,
        cacheTime: 5 * 60 * 1000, // 5 minutes
    });

    const { isLoading, error, ...rest } = query;

    return {
        companies: query.data || [],
        isLoading,
        error,
        ...rest,
    };
};
